import IOfferPageContent from '../../models/offer-page/offer-page-content.model';

export const offersPageContent: IOfferPageContent = {
  title: 'Unsere Unis',
  subtitle: '',
  appealTitle: 'Studierenden',
};
